(ns splash.constants.splash-document-statuses.core
  (:require
    [splash.libraries.constants.build-utils :as build-utils]))

(def ^:const unverified 1)
(def ^:const approved 2)
(def ^:const rejected 3)
(def ^:const new 4)

(def splash-document-statuses
  "The underlying data for the translator to consume"
  ^{:domain-attributes #{}
    :monolith-table    "splash_document_statuses"}
  [{:id      unverified
    :enum    "Unverified"
    :display "Unverified"}
   {:id      approved
    :enum    "Approved"
    :display "Approved"}
   {:id      rejected
    :enum    "Rejected"
    :display "Rejected"}
   {:id      new
    :enum    "New"
    :display "New"}])

(def translator
  "A translator to be provided to the `translate` functions"
  (build-utils/->translator splash-document-statuses))

(defn ->display
  [splash-document-status-id]
  (get-in translator [:id splash-document-status-id :display]))

(defn ->enum
  [splash-document-status-id]
  (get-in translator [:id splash-document-status-id :enum]))

(defn approved?
  [splash-document-status-id]
  (= approved splash-document-status-id))
